import { render, staticRenderFns } from "./UserPianziListPop.vue?vue&type=template&id=1722c74c&"
import script from "./UserPianziListPop.vue?vue&type=script&lang=js&"
export * from "./UserPianziListPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports